import { Box } from "@chakra-ui/react";

import { Header } from "src/components/shared/Header";
import { Text } from "src/components/text";

export const NotFoundPage: React.FC = () => {
  return (
    <Box p={10}>
      <Header />

      <Text as="h2">
        Page Not Found
      </Text>

      <Text>
        The page you're looking for doesn't seem to exist. Are you sure that the URL is correct?
      </Text>
    </Box>
  );
};